import { Box, Button, Divider, Heading, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import { formattedCurrency } from '../../../helper/utils/formattedCurrency';

export default function TransactionDetailModal({ isOpen, onClose, historyTransactionDetail }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size='xl' scrollBehavior='inside'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Transaction Detail</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {historyTransactionDetail ? (
                        <VStack align='stretch' spacing={4}>
                            <Box>
                                <HStack justifyContent='space-between'>
                                    <Text fontWeight='bold'>Bill No:</Text>
                                    <Text>{historyTransactionDetail.header?.billNo}</Text>
                                </HStack>
                                <HStack justifyContent='space-between'>
                                    <Text fontWeight='bold'>Date:</Text>
                                    <Text>
                                        {historyTransactionDetail.header?.billDate} {historyTransactionDetail.header?.BillTime}
                                    </Text>
                                </HStack>
                                <HStack justifyContent='space-between'>
                                    <Text fontWeight='bold'>Outlet:</Text>
                                    <Text>{historyTransactionDetail.header?.outletName}</Text>
                                </HStack>
                            </Box>
                            <Divider />
                            <Box>
                                <Heading size='sm' mb={2}>
                                    Items
                                </Heading>
                                <VStack align='stretch' spacing={2}>
                                    {historyTransactionDetail.detail?.map((item, idx) => (
                                        <Box key={idx} p={3} borderWidth={1} borderRadius='md'>
                                            <HStack justifyContent='space-between' mb={1}>
                                                <Text fontWeight='semibold'>{item.menuName}</Text>
                                                <Text>{formattedCurrency(item.total)}</Text>
                                            </HStack>
                                            <HStack justifyContent='space-between' fontSize='sm' color='gray.600'>
                                                <Text>
                                                    {item.qty} x {formattedCurrency(item.price)}
                                                </Text>
                                                {item.discValue && parseFloat(item.discValue) > 0 && (
                                                    <Text color='red.500'>- {formattedCurrency(item.discValue)}</Text>
                                                )}
                                            </HStack>
                                        </Box>
                                    ))}
                                </VStack>
                            </Box>
                            <Divider />
                            <Box>
                                <HStack justifyContent='space-between'>
                                    <Text>Subtotal:</Text>
                                    <Text>{formattedCurrency(historyTransactionDetail.header?.subTotal)}</Text>
                                </HStack>
                                <HStack justifyContent='space-between' color='red.500'>
                                    <Text>Discount:</Text>
                                    <Text>- {formattedCurrency(historyTransactionDetail.header?.discValue)}</Text>
                                </HStack>
                                <HStack justifyContent='space-between' fontWeight='bold' mt={2}>
                                    <Text>Grand Total:</Text>
                                    <Text>{formattedCurrency(historyTransactionDetail.header?.grandTotal)}</Text>
                                </HStack>
                            </Box>
                            {historyTransactionDetail.payment?.length > 0 && (
                                <>
                                    <Divider />
                                    <Box>
                                        <Heading size='sm' mb={2}>
                                            Payment Info
                                        </Heading>
                                        {historyTransactionDetail.payment.map((pay, idx) => (
                                            <HStack key={idx} justifyContent='space-between' fontSize='sm'>
                                                <Text>
                                                    {pay.paidby} {pay.cardNo && pay.cardNo !== '-' ? `(${pay.cardNo})` : ''}
                                                </Text>
                                                <Text>{formattedCurrency(pay.paidValue)}</Text>
                                            </HStack>
                                        ))}
                                    </Box>
                                </>
                            )}
                        </VStack>
                    ) : (
                        <Text textAlign='center' py={4}>
                            Loading detail...
                        </Text>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='primary' mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
